import React, { useState, useRef, useEffect } from "react";
import { useTranslation } from "react-i18next";

const LANGUAGES = [
  { code: "pt", name: "Português", flag: "🇵🇹" },
  { code: "en", name: "English", flag: "🇬🇧" },
  { code: "es", name: "Español", flag: "🇪🇸" },
  { code: "fr", name: "Français", flag: "🇫🇷" },
  { code: "de", name: "Deutsch", flag: "🇩🇪" },
  { code: "it", name: "Italiano", flag: "🇮🇹" },
];

const PublicLanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const ref = useRef(null);

  const current =
    LANGUAGES.find((l) => l.code === i18n.language) || LANGUAGES[0];

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setIsOpen(false);
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleChange = (code) => {
    localStorage.setItem("lng", code);
    i18n.changeLanguage(code);
    setIsOpen(false);
    window.location.reload();
  };

  return (
    <div
      ref={ref}
      className="public-lang-switcher"
      style={{ position: "relative", marginRight: "12px" }}
    >
      <button
        type="button"
        onClick={() => setIsOpen(!isOpen)}
        style={{
          background: "transparent",
          border: "1px solid rgba(0,0,0,0.15)",
          borderRadius: "6px",
          padding: "6px 10px",
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          gap: "6px",
          fontSize: "14px",
        }}
      >
        <span style={{ fontSize: "18px" }}>{current.flag}</span>
        <span>{current.code.toUpperCase()}</span>
        <i
          className="bi bi-chevron-down"
          style={{ fontSize: "12px", marginLeft: "2px" }}
        />
      </button>

      {isOpen && (
        <ul
          style={{
            position: "absolute",
            top: "calc(100% + 6px)",
            right: 0,
            margin: 0,
            padding: "4px 0",
            listStyle: "none",
            background: "#fff",
            border: "1px solid rgba(0,0,0,0.1)",
            borderRadius: "8px",
            boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
            minWidth: "160px",
            zIndex: 1000,
          }}
        >
          {LANGUAGES.map((lang) => (
            <li key={lang.code}>
              <button
                type="button"
                onClick={() => handleChange(lang.code)}
                style={{
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  padding: "8px 12px",
                  background:
                    lang.code === current.code
                      ? "rgba(0,0,0,0.04)"
                      : "transparent",
                  border: "none",
                  cursor: "pointer",
                  fontSize: "14px",
                  textAlign: "left",
                }}
              >
                <span style={{ fontSize: "18px" }}>{lang.flag}</span>
                <span>{lang.name}</span>
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default PublicLanguageSwitcher;
